import { render, staticRenderFns } from "./PacientesDetallePagos.vue?vue&type=template&id=678ea276&"
import script from "./PacientesDetallePagos.vue?vue&type=script&lang=js&"
export * from "./PacientesDetallePagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports